import React, { Component } from "react";
import Switch from "react-switch";
import Navbar from "../../components/Navbar.js";
import { alert, GET, POST, PUT, loading } from "../../components/CustomComponent.js";
import Resizer from "react-image-file-resizer";
import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";
export default class announcements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,
      modal_detail: false,

      count: 0,

      uid: "",
      image: "",
      description: "",
      is_active: false
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    loading(true);
    let body = {
      page: page,
    };
    let result = await GET("api/admin/announcements/list", body);
    if (result?.status) {
      this.setState({ uid: result.data?.uid,
image: result.data?.image,
description: result.data?.description,
is_active: result.data?.is_active,});
    }
    loading(false);
  };
  CreateUpdate = async () => {
    const {uid, description, image, is_active} = this.state;
    loading(true);
    let new_image = image;
     if (image && image.includes("base64")) {
              const res = await POST("api/admin/upload-data/image", {
                image_slip: [image],
              });
              new_image = res.data[0];
            }
    let body = {
      description,
      image: new_image,
      is_active
    };
    let result = !uid
      ? await POST("api/admin/announcements/create", body)
      : await PUT("api/admin/announcements/update/" + uid, body);
    if (result?.status) {
      alert("#", "success");
    }
    loading(false);
  };
  // ★ รูปเดียวกันใช้ทั้งช่องอัปโหลดและกล่องตัวอย่าง — แยกเป็นฟังก์ชันกันเขียนซ้ำ
  pickImage = async (file) => {
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      alert("", "warning", "ไฟล์ใหญ่เกินไป", "รูปประกาศต้องมีขนาดไม่เกิน 5 MB");
      return;
    }
    const image = await new Promise((resolve) => {
      Resizer.imageFileResizer(file, 1200, 1200, "JPEG", 100, 0, (uri) => resolve(uri), "base64");
    });
    this.setState({ image });
  };

  render() {
    const { image, description, is_active } = this.state;

    return (
      <div className="w-100 min-vh-100">
        <Navbar header="Transaction History" page1="หน้าหลัก" page2="ประกาศแจ้งเตือน" />

        <div className="body px-3 pb-4 pt-0">
          {/* ---------------- หัวหน้า ---------------- */}
          <div className="ann-hero rounded-4 p-4 mb-3">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
              <div>
                <h3 className="fw-bold mb-1">ประกาศแจ้งเตือน</h3>
                <div className="text-secondary">
                  ประกาศนี้จะเด้งขึ้นให้ลูกบ้านเห็นตอนเข้าใช้งานระบบ — มีได้ครั้งละ 1 ประกาศ
                </div>
              </div>
              <span className={`ann-state ${is_active ? "is-on" : ""}`}>
                <span className="icon">{is_active ? "\uf058" : "\uf05e"}</span>
                {is_active ? "กำลังแสดงอยู่" : "ปิดการแสดง"}
              </span>
            </div>
          </div>

          <div className="row g-3">
            {/* ---------------- ฟอร์ม ---------------- */}
            <div className="col-12 col-lg-7">
              <div className="card border-0 shadow-sm rounded-4 h-100">
                <div className="p-4">
                  <input
                    hidden
                    accept="image/*"
                    id="image"
                    type="file"
                    onChange={(e) => {
                      this.pickImage(e.target.files?.[0]);
                      e.target.value = "";
                    }}
                  />

                  <label className="fw-bold mb-2">รูปภาพประกาศ</label>
                  {image ? (
                    <div className="ann-image position-relative">
                      <img alt="ประกาศ" src={image} />
                      <button
                        type="button"
                        className="ann-image__remove icon"
                        title="ลบรูป"
                        onClick={() => this.setState({ image: "" })}
                      >
                        {"\uf00d"}
                      </button>
                      <button
                        type="button"
                        className="ann-image__change"
                        onClick={() => document.getElementById("image").click()}
                      >
                        เปลี่ยนรูป
                      </button>
                    </div>
                  ) : (
                    /* ลากไฟล์มาวางได้เลย ไม่ต้องกดหาปุ่ม */
                    <div
                      className="ann-drop"
                      onClick={() => document.getElementById("image").click()}
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      onDrop={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.pickImage(e.dataTransfer.files?.[0]);
                      }}
                    >
                      <span className="icon text-32">{"\uf03e"}</span>
                      <div className="fw-bold mt-2">ลากรูปมาวาง หรือกดเพื่อเลือกไฟล์</div>
                      <small className="text-secondary">
                        แนะนำไม่เกิน 1780×1280 พิกเซล · PNG, JPG, JPEG, GIF · ไม่เกิน 5 MB
                      </small>
                    </div>
                  )}

                  <div className="mt-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <label className="fw-bold mb-0">รายละเอียด</label>
                      <small className="text-secondary">{(description || "").length} ตัวอักษร</small>
                    </div>
                    <textarea
                      className="form-control"
                      rows={8}
                      placeholder="เช่น ปิดน้ำชั่วคราววันที่ 30 ส.ค. เวลา 09:00-12:00 เพื่อล้างถังเก็บน้ำ"
                      value={description}
                      onChange={(e) => this.setState({ description: e.target.value })}
                    />
                  </div>

                  <div className="ann-switch mt-4">
                    <div>
                      <div className="fw-bold">แสดงประกาศนี้กับลูกบ้าน</div>
                      <small className="text-secondary">ปิดไว้ = เก็บข้อความไว้ในระบบ แต่ยังไม่เด้งให้ใครเห็น</small>
                    </div>
                    <Switch onChange={(e) => this.setState({ is_active: e })} checked={is_active} onColor="#198754" />
                  </div>

                  <div className="d-flex justify-content-end mt-4">
                    <button className="btn btn-success px-5" onClick={() => this.CreateUpdate()}>
                      บันทึก
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* ---------------- ตัวอย่างที่ลูกบ้านจะเห็น ----------------
                ★ ประกาศเด้งเป็นป๊อปอัป การแก้ข้อความ/รูปจึงต้องเห็นผลทันทีข้าง ๆ ฟอร์ม
                  ไม่ต้องบันทึกก่อนแล้วไปเปิดแอปดู */}
            <div className="col-12 col-lg-5">
              <div className="card border-0 shadow-sm rounded-4 h-100">
                <div className="px-4 pt-4">
                  <div className="fw-bold">ตัวอย่างที่ลูกบ้านจะเห็น</div>
                  <small className="text-secondary">อัปเดตตามที่กรอกทางซ้ายทันที</small>
                </div>
                <div className="p-4">
                  <div className="ann-preview">
                    {image ? (
                      <img alt="ตัวอย่างประกาศ" src={image} />
                    ) : (
                      <div className="ann-preview__ghost icon">{"\uf03e"}</div>
                    )}
                    <div className="ann-preview__body">
                      {description ? (
                        description.split("\n").map((line, index) => (
                          <div key={`preview-line-${index}`}>{line}</div>
                        ))
                      ) : (
                        <span className="text-secondary">ยังไม่ได้ใส่รายละเอียด</span>
                      )}
                    </div>
                    <div className="ann-preview__foot">
                      <span className="btn btn-success btn-sm px-4">รับทราบ</span>
                    </div>
                  </div>

                  {!is_active && (
                    <div className="ann-note mt-3">
                      ตอนนี้ปิดการแสดงอยู่ — เปิดสวิตช์แล้วกดบันทึก ลูกบ้านถึงจะเห็นประกาศนี้
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
